import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import PageHead from '@/components/PageHead/PageHead';
import { extractContents } from '@/helpers/extractContents';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import { PageModelBase } from '@/models/page';
import { CmsComponentsContext } from '../CmsComponentsContext';
import cmsComponents from './EMobilityProductPage.cmsComponents';
import EMobilityProductPageContent from './EMobilityProductPage.content';

const EMobilityProductPage = (pageData: PageModelBase<{}>) => {
  const meta = extractPageMetaFromRouteData(pageData);
  const {
    extractedContents: [noticeBarArea],
  } = extractContents(['notice-bar-area', 'header'], pageData.contents);

  useInitialPageDataLayer();

  return (
    <CmsComponentsContext.Provider value={cmsComponents}>
      <PageHead {...meta} />
      {noticeBarArea && <ContentsToReact contents={noticeBarArea} />}
      <EMobilityProductPageContent />
    </CmsComponentsContext.Provider>
  );
};

export default EMobilityProductPage;
